import { ICancelarOrdemCompraUseCase } from "../../../presentation/useCases/update/cancelar_ordem_compra_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * CancelarOrdemCompraUseCase
 */

export class CancelarOrdemCompraUseCase implements ICancelarOrdemCompraUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async cancelarOrdemCompra(
    idOrdemCompra: number,
    motivo: string | null,
  ): Promise<void> {
    await this.repository.cancelarOrdemCompra(
      idOrdemCompra,
      motivo,
    );
  }
}
